import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL

class ProjectService {
  /**
   * Get all projects for an agent
   */
  getProjectsByAgent (agentId) {
    return axios.get(API_URL + 'agents/' + agentId + '/projects')
  }

  /**
   * Get project details
   */
  getProjectById (agentId, projectId) {
    return axios.get(API_URL + 'agents/' + agentId + '/projects/' + projectId)
  }

  /**
   * Create new project
   */
  createProject (agentId, projectData) {
    return axios.post(API_URL + 'agents/' + agentId + '/projects', projectData)
  }

  /**
   * Update project
   */
  updateProject (agentId, projectId, projectData) {
    return axios.put(API_URL + 'agents/' + agentId + '/projects/' + projectId, projectData)
  }

  /**
   * Delete project
   */
  deleteProject (agentId, projectId) {
    return axios.delete(API_URL + 'agents/' + agentId + '/projects/' + projectId)
  }

  /**
   * Get sessions for a project
   */
  getProjectSessions (agentId, projectId) {
    return axios.get(API_URL + 'agents/' + agentId + '/projects/' + projectId + '/sessions')
  }

  getProjectKnowledgeBases (agentId, projectId) {
    return axios.get(API_URL + 'agents/' + agentId + '/projects/' + projectId + '/knowledge-bases')
  }

  createProjectKnowledgeBase (agentId, projectId, kbData) {
    return axios.post(API_URL + 'agents/' + agentId + '/projects/' + projectId + '/knowledge-bases', kbData)
  }
}

export default new ProjectService()
